






































import { defineComponent, onMounted, Ref, ref, reactive, watchEffect } from '@vue/composition-api';

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IRangeState {
	initialValue: number;
	initialStep: number;
	step: number;
	value: number;
}

export default defineComponent({
	props: {
		min: {
			type: Number,
			required: true,
		},
		max: {
			type: Number,
			required: true,
		},
		initialStep: {
			type: Number,
			required: true,
		},
		initialValue: {
			type: Number,
			required: true,
		},
	},

	setup(props) {
		const formatter = new Intl.NumberFormat('de-DE');
		const rangeInputRef: Ref<HTMLInputElement | null> = ref(null);
		const numberInputRef: Ref<HTMLInputElement | null> = ref(null);
		const state: IRangeState = reactive({
			initialValue: props.initialValue,
			initialStep: props.initialStep,
			step: 0,
			value: 0,
		});

		function onNumberInputChange() {
			state.step = 1;
			const numberInputEl = numberInputRef.value;
			if (!numberInputEl) {
				return;
			}
			const numberInputValue = parseInt(numberInputEl.value);
			if (!isNaN(numberInputValue)) {
				state.value = numberInputValue;
			}
		}

		function onBlur() {
			if (state.value < props.min) {
				state.value = props.min;
			}
			if (state.value > props.max) {
				state.value = props.max;
			}
		}

		function onMouseDown() {
			state.step = state.initialStep;
			if (state.value % state.step !== 0) {
				state.value -= state.value % state.step;
			}
		}

		function handleRangeColorChange() {
			const rangeInputEl = rangeInputRef.value;
			if (!rangeInputEl) {
				return;
			}
			if (state.value < props.min) {
				return (rangeInputEl.style.backgroundSize = '0% 100%');
			}
			if (state.value > props.max) {
				return (rangeInputEl.style.backgroundSize = '100% 100%');
			}
			rangeInputEl.style.backgroundSize = ((state.value - props.min) * 100) / (props.max - props.min) + '% 100%';
		}

		onMounted(() => {
			state.value = state.initialValue;
			state.step = state.initialStep;
			handleRangeColorChange();
		});

		watchEffect(() => {
			handleRangeColorChange();
		});

		return { formatter, rangeInputRef, numberInputRef, state, onNumberInputChange, onBlur, onMouseDown };
	},
});
